import styled from 'styled-components';

import { getCombinedClassNames } from 'utils/style';

import themConfigs from 'config/theme';

const fullConfig = { theme: themConfigs };

const FormRow = styled.div`
  @media (min-width: ${fullConfig.theme.screens.md}) {
    min-height: 600px;
    figure {
        height 600px;
    }
  }

  @media (min-width: ${fullConfig.theme.screens.xl}) {
    min-height: 650px;
  }
`;

const FormImageWrap = styled.figure.attrs(() => {
  const classNameToAdd = [
    'hidden',
    'md:block',
    'absolute',
    'right-1/2',
    'left-0',
    'w-1/2',
    'top-0',
    'bottom-0',
    'overflow-hidden',
    'rounded-r-base',
  ];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

// [SW-654] Weird IE11 hack
// Had to split up the label properties in two
const FormInput = styled.input`
  &:focus ~ label,
  &:not(:-ms-input-placeholder) ~ label {
    top: -20px;
    font-size: 12px;
  }

  &:focus ~ label,
  &:not(:placeholder-shown) ~ label {
    top: -20px;
    font-size: 12px;
  }

  &:not(:placeholder-shown):invalid:required ~ label {
    color: ${fullConfig.theme.extend.colors.notification.error};
  }

  &:not(:placeholder-shown):valid:required ~ label {
    color: ${fullConfig.theme.extend.colors.notification.success};
  }
`;

// [SW-654] Weird IE11 hack
// Had to split up the label properties in two
const FormText = styled.textarea`
  min-height: 60px;
  max-height: 440px;

  &:focus ~ label,
  &:not(:placeholder-shown) ~ label {
    top: -20px;
    font-size: 12px;
  }

  &:focus ~ label,
  &:not(:-ms-input-placeholder) ~ label {
    top: -20px;
    font-size: 12px;
  }
`;

const Notification = styled.div.attrs(({ type }) => {
  const typeClass = type === 'error' ? 'text-notification-error' : 'text-notification-success';
  const classNamesToAdd = [typeClass];
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})``;

export { FormRow, FormImageWrap, FormInput, FormText, Notification };
